import ApiService from './ApiService';

const ActivityService = {
  list: ({ limit = 50, before } = {}) => ApiService.get('/activity', { limit, before }),
};

export default ActivityService;
